import React, { useEffect, useMemo, useRef, useState } from "react";
import UpgradePopup from "./upgradePopup";

export default function PremiumUpgradeReminder({ open, setOpen }) {
  const timerRef = useRef(null);
  const [internalOpen, setInternalOpen] = useState(false);
  const user = useMemo(() => {
    try {
      const raw = sessionStorage.getItem("userDetails");
      return raw ? JSON.parse(raw) : null;
    } catch {
      return null;
    }
  }, []);

  const isBuyer =
    user?.result?.role?.id === 3 &&
    user?.result?.loggedinprofiletype === "buyerprofile";
  const effectiveOpen = typeof open === "boolean" ? open : internalOpen;
  const setEffectiveOpen =
    typeof setOpen === "function" ? setOpen : setInternalOpen;
  useEffect(() => {
    if (!isBuyer) return;
    if (timerRef.current) clearInterval(timerRef.current);
    timerRef.current = setInterval(() => {
      setEffectiveOpen(true);
    }, 5 * 60 * 1000);
    return () => {
      if (timerRef.current) clearInterval(timerRef.current);
    };
  }, [isBuyer]);

  const plans = [
    {
      name: "interacOnlyPlan",
      description: "interacOnlyPlanDescription",
      price: "Free",
    },
    {
      name: "silverPlan",
      description: "silverPlanDescription",
      price: "$499",
    },
    {
      name: "goldPlan",
      description: "goldPlanDescription",
      price: "$999",
    },
  ];

  return (
    <UpgradePopup
      open={isBuyer && open}
      onClose={() => setOpen(false)}
      plans={plans}
    />
  );
}
